import "@/App.css";
import { SmoothScroll } from "@/components/SmoothScroll";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Manifesto } from "@/components/Manifesto";
import { About } from "@/components/About";
import { Programs } from "@/components/Programs";
import { Careers } from "@/components/Careers";
import { Vacancies } from "@/components/Vacancies";
import { FAQ } from "@/components/FAQ";
import { Insights } from "@/components/Insights";
import { ApplyForm } from "@/components/ApplyForm";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App grain min-h-screen bg-ink text-bone">
      <SmoothScroll>
        <Navbar />
        <main>
          <Hero />
          <Marquee />
          <Manifesto />
          <About />
          <Programs />
          <Careers />
          <Vacancies />
          <Insights />
          <FAQ />
          <ApplyForm />
          <Contact />
        </main>
        <Footer />
      </SmoothScroll>
      <Toaster position="bottom-right" theme="dark" />
    </div>
  );
}

export default App;
